export { default } from "./labItem";
